import {
  DISPLAY_STYLE_SECTION_TOP,
  DISPLAY_STYLE_SECTION_HEADER,
  DISPLAY_STYLE_SECTION_HEADER_NEXT_SIBLING,
  DISPLAY_STYLE_SECTION_FOOTER,
  DISPLAY_STYLE_SECTION_FOOTER_LEFT,
  DISPLAY_STYLE_SECTION_FOOTER_CENTER,
  DISPLAY_STYLE_SECTION_FOOTER_RIGHT,
  DISPLAY_STYLE_SECTION_FOOTER_ONE_ELEMENT,
} from "components/Shared/MGridForm";

//  Section Array Shape
// [
//   {
//     name: 'section 1',
//     rows: [
//       [
//         {
//           label: 'row 1 field 1',
//         },
//         {
//           label: 'row 1 field 2',
//         },
//       ],
//       [
//         {
//           label: 'row 2 field 1',
//         },
//         {
//           label: 'row 2 field 2',
//         },
//       ],
//     ]
//   },
//   {
//     name: 'section 2',
//     rows: [
//       [
//         {
//           label: 'row 1 field 1',
//         },
//         {
//           label: 'row 1 field 2',
//         },
//       ],
//       [
//         {
//           label: 'row 2 field 1',
//         },
//         {
//           label: 'row 2 field 2',
//         },
//       ],
//     ]
//   },
// ]

export default sections => sections.map(({ name, rows }) => {
  return [
    ...name
      ? [getSectionHeader(name)]
      : [],
    ...rows.length === 1 ? ([
      addClassNamesToRowStyle({ classNames: getHeaderNextSiblingStyles(name), row: addFooterClassNamesToRow(rows[0]) })
    ]) : (
        rows.length === 2 ? ([
          addClassNamesToRowStyle({ classNames: getHeaderNextSiblingStyles(name), row: rows[0] }),
          addFooterClassNamesToRow(rows[1]),
        ]) : ([
          addClassNamesToRowStyle({ classNames: getHeaderNextSiblingStyles(name), row: rows[0] }),
          ...rows.slice(1, -1),
          addFooterClassNamesToRow(rows[rows.length - 1]),
        ])
      )
  ];
}).flat().map(row => row.map(({ style, ...restField }) => ({
  ...restField,
  style: {
    ...style,
    borderBottom: 0,
  },
})));

const getHeaderNextSiblingStyles = name => ([
  DISPLAY_STYLE_SECTION_HEADER_NEXT_SIBLING,
  ...name ? [] : [DISPLAY_STYLE_SECTION_TOP]
]);

const getSectionHeader = name => [{
  label: name,
  style: { className: DISPLAY_STYLE_SECTION_HEADER },
}];

const addClassNamesToRowStyle = ({ classNames, row }) => row.map(field => addClassNamesToFieldStyle({ classNames, field }));

const addClassNamesToFieldStyle = ({ classNames, field: { style, ...restField } }) => ({
  ...restField,
  style: {
    ...style,
    className: (style && style.className) ? (
      Array.isArray(style.className) ? (
        [...style.className, ...classNames]
      ) : (
          [style.className, ...classNames]
        )
    ) : (
        classNames
      ),
  },
});

const addFooterClassNamesToRow = row =>
  row.length === 1 ? (
    addClassNamesToRowStyle({ classNames: [DISPLAY_STYLE_SECTION_FOOTER_ONE_ELEMENT, DISPLAY_STYLE_SECTION_FOOTER], row })
  ) : (
      row.length === 2 ? ([
        addClassNamesToFieldStyle({ classNames: [DISPLAY_STYLE_SECTION_FOOTER_LEFT, DISPLAY_STYLE_SECTION_FOOTER], field: row[0] }),
        addClassNamesToFieldStyle({ classNames: [DISPLAY_STYLE_SECTION_FOOTER_RIGHT, DISPLAY_STYLE_SECTION_FOOTER], field: row[1] }),
      ]) : ([
        addClassNamesToFieldStyle({ classNames: [DISPLAY_STYLE_SECTION_FOOTER_LEFT, DISPLAY_STYLE_SECTION_FOOTER], field: row[0] }),
        ...addClassNamesToRowStyle({ classNames: [DISPLAY_STYLE_SECTION_FOOTER_CENTER, DISPLAY_STYLE_SECTION_FOOTER], row: row.slice(1, -1) }),
        addClassNamesToFieldStyle({ classNames: [DISPLAY_STYLE_SECTION_FOOTER_RIGHT, DISPLAY_STYLE_SECTION_FOOTER], field: row[row.length - 1] }),
      ])
    );